export const HINT_ICON_BY_TYPE = {
  remove2: "🎯",
  autoPass: "✅",
  pause: "⏸️",
};

export const SHOP_COIN_ICON = "💰";
export const DAILY_BOOSTER_ICON = "🎡";
